import {Badge, Box, IconButton, ListItem, Tooltip, Typography} from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import React from "react";

const ChatPatient = ({
                         patientName,
                         patientPhone,
                         message,
                         func,
                         selected,
                         isRead,
                         lastMessageAt,
                         lastRequestDate,
                         hasActiveRequests,
                         sortBy,
                         adminName,
                         onMarkAsRead,
                     }) => {
    // форматируем дату
    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const now = new Date();
        const diffMs = now - d;
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor(diffMs / (1000 * 60));

        // Если меньше часа - показываем минуты
        if (diffMinutes < 60) {
            if (diffMinutes < 1) return "только что";
            return `${diffMinutes} мин назад`;
        }

        // Если меньше 24 часов - показываем часы
        if (diffHours < 24) {
            return `${diffHours} ч назад`;
        }

        // Если сегодня - показываем время
        const isToday = d.toDateString() === now.toDateString();
        if (isToday) {
            return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        }

        // Иначе показываем дату
        return d.toLocaleDateString();
    };

    const showReadButton = !isRead && !!lastMessageAt && !!onMarkAsRead;

    return (
        <ListItem
            button
            onClick={func}
            selected={selected}
            sx={{
                backgroundColor: selected ? "action.selected" : "inherit",
                "&:hover": {backgroundColor: "action.hover"},
                py: 1.5,
                px: 2,
                gap: 1.5,
                alignItems: "stretch",
            }}
        >
            {/* Индикаторы слева */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 1.1,
                    minWidth: "12px",
                    pt: 1.25
                }}
            >
                {(!isRead && lastMessageAt) && (
                    <Badge
                        color="primary"
                        variant="dot"
                        overlap="circular"
                    />
                )}
                {hasActiveRequests && (
                    <Badge
                        color="error"
                        variant="dot"
                        overlap="circular"
                    />
                )}
            </Box>

            {/* Основной контент */}
            <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 0.5 }}>
                {/* Имя пациента + иконка занятого чата */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: isRead ? "normal" : "bold",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {patientName}
                    </Typography>
                    {adminName && (
                        <Tooltip title={adminName} placement="top">
                            <SupportAgentIcon sx={{ fontSize: "0.95rem", color: "primary.main", flexShrink: 0 }} />
                        </Tooltip>
                    )}
                </Box>

                {/* Телефон */}
                <Typography
                    variant="caption"
                    sx={{
                        color: "text.secondary",
                        fontSize: "0.7rem"
                    }}
                >
                    {patientPhone}
                </Typography>

                {/* Последнее сообщение */}
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                        fontWeight: isRead ? "normal" : "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "0.8rem",
                        mt: 0.5,
                    }}
                >
                    {(message || lastMessageAt) ? (message ? message : '[Вложение]') : "Нет сообщений"}
                </Typography>
            </Box>

            {/* Правая колонка: дата + имя админа + кнопка прочитать */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "flex-start",
                    gap: 0.5,
                    minWidth: 0,
                    width: "80px",
                    flexShrink: 0,
                }}
            >
                {/* Верх: дата */}
                {sortBy === 'requests' ? (
                    hasActiveRequests && lastRequestDate && (
                        <Typography
                            variant="caption"
                            sx={{
                                color: "error.main",
                                fontWeight: "bold",
                                fontSize: "0.7rem",
                                whiteSpace: "nowrap"
                            }}
                        >
                            {formatDate(lastRequestDate)}
                        </Typography>
                    )
                ) : (
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontSize: "0.7rem", whiteSpace: "nowrap" }}
                    >
                        {formatDate(lastMessageAt)}
                    </Typography>
                )}

                {/* Кнопка "прочитать" */}
                {showReadButton && (
                    <Tooltip title="Отметить как прочитанное">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onMarkAsRead();
                            }}
                            sx={{ p: 0.25 }}
                        >
                            <DoneAllIcon fontSize="small" color="primary" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        </ListItem>
    );
};

export default ChatPatient;
